import React, { useState, useEffect } from "react";
import logo from "../images/managekaro logo.png";
import jsPDF from "jspdf";
import DataTable from "react-data-table-component";
import { DialogContent, TextField, Dialog, Box } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import Repo from "../Repository/Repo";
import { Typography } from "@mui/material";

const columns = [
  {
    name: "#",
    selector: (row, index) => index + 1,
  },
  {
    name: "Warehouse Number",
    selector: (row) => {
      if (row.billNumber != "") {
        return row.billNumber;
      } else {
        return "#";
      }
    },
  },
  {
    name: "Date",
    selector: (row) => row.date,
  },
];

function WarehouseBills() {
  const [totalBills, setTotalBills] = useState([]);
  const [bill, setBill] = useState("");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [open, setOpen] = React.useState(false);
  const [next_page_token, setNext_page_token] = React.useState("");

  const handleClose = () => {
    setLoading(true);
    getBills();
    setOpen(false);
  };

  useEffect(() => {
    getBills();
  }, []);

  function timeConverter(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp * 1000);
    var months = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "Sep",
      "Oct",
      "Nov",
      "12",
    ];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = date + "-" + month + "-" + year;
    return time;
  }

  function handleShowBills(row) {
    setBill(row);
    setOpen(true);
  }

  function getBills() {
    Repo.warehouseBill({
      request: {
        method: "getWarehouseBills",
        data: {
          company_code: localStorage.getItem("companyCode"),
          next_page_token: next_page_token,
        },
      },
    }).then((res) => {
      setTotalBills(res.data.response.data.billsArr);
      setLoading(false);
    });
  }

  async function printdocNEW() {
    var doc = new jsPDF();

    doc.setFontSize(18);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company"), 50, 22);
    doc.setFontSize(26);
    doc.text("BILL DETAIL", 120, 35);

    doc.setFontSize(12);
    doc.setFontStyle("normal");

    doc.text("Date:", 120, 45);
    doc.text(bill?.date, 165, 45);

    doc.text("Warehouse Number:", 120, 55);
    doc.text(bill?.billNumber.toString(), 170, 55);

    doc.setFontSize(12);
    doc.text("SHOP", 21, 48);

    doc.setFontStyle("normal");

    doc.text(
      localStorage.getItem("company") == null
        ? ""
        : localStorage.getItem("company"),
      20,
      55
    );
    doc.text(
      localStorage.getItem("address") == null
        ? ""
        : localStorage.getItem("address"),
      20,
      62
    );
    doc.text(
      localStorage.getItem("phone") == null
        ? ""
        : localStorage.getItem("phone"),
      20,
      69
    );

    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("#", 21, 90);
    doc.text("Item", 40, 90);
    doc.text("Quantity", 140, 90);

    doc.cell(20, 84, 170, 8, " ");

    let y = 92;

    bill?.quantity.map((item, index) => {
      doc.setFontSize(14);
      doc.setFontStyle("bold");
      doc.cell(20, y, 12, 6, " ");
      doc.cell(32, y, 130, 6, " ");
      doc.cell(137, y, 25, 6, " ");
      doc.cell(162, y, 28, 6, " ");

      doc.setFontSize(12);
      doc.setFontStyle("normal");
      doc.text((index + 1).toString(), 22, y + 5);
      doc.text(item.name, 34, y + 5);

      doc.text(item.saleQuantity.toString(), 139, y + 5);
      y = y + 6;

      if (y >= 240) {
        doc.addPage();
        y = 20;
      }
    });

    doc.setFontSize(10);

    doc.text(
      localStorage.getItem("terms") != null
        ? localStorage.getItem("terms")
        : "",
      58,
      270
    );

    doc.text("Powered by www.hardwarepakistan.com", 68, 280);
    doc.text("0342-5588269", 88, 290);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <TextField
        label="Search"
        name="text"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const filteredItems = () => {
    if (filterText !== "") {
      return totalBills?.filter((item) =>
        item?.billNumber.toString().includes(filterText)
      );
    } else {
      return totalBills;
    }
  };

  return (
    <div style={{ paddingBottom: "30px" }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ClipLoader color="#4caf50" loading={loading} size={50} />
      </Box>
      <Typography
        className="green"
        sx={{
          mt: { md: "10px", xs: "40px" },
          fontSize: { md: "2.125rem", xs: "16px" },
        }}
      >
        Warehouse Bills
      </Typography>

      <DataTable
        columns={columns}
        data={filteredItems()}
        highlightOnHover={true}
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onRowClicked={handleShowBills}
        pointerOnHover={true}
        Clicked
      />

      <Dialog
        open={open}
        maxWidth={maxWidth}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <button className="bill-btn" onClick={handleClose}>
            Go Back
          </button>

          <button
            className="bill-btn"
            onClick={() => {
              printdocNEW();
            }}
          >
            Print
          </button>

          <div className="purchase-bill" id="purchase-order">
            <div className="purchase-bill-header">
              <h1 className="purchase-title">BILL DETAIL</h1>
              <p className="purchase-subtitle">
                Warehouse Number {bill?.billNumber}
              </p>
              <div className="purchase-date flex">
                <p>DATE: </p>
                <p>{timeConverter(bill?.created_at)}</p>
              </div>

              <div
                className="purchase-company-details"
                style={{ display: "flex" }}
              >
                <img
                  src={
                    localStorage.getItem("base_url") == null
                      ? logo
                      : localStorage.getItem("base_url")
                  }
                  width="100"
                ></img>
                <h2 style={{ margin: "20px" }}>
                  {localStorage.getItem("company")}
                </h2>
              </div>
            </div>
            {
              <>
                <div className="purchase-vendor-div">
                  <h3 className="vendor-title">STORE </h3>
                  <p className="no-margin-padding">
                    {localStorage.getItem("company")}
                  </p>
                  <p className="no-margin-padding">
                    {localStorage.getItem("address")}
                  </p>
                  <p className="no-margin-padding">
                    {localStorage.getItem("email")}
                  </p>
                  <p className="no-margin-padding">
                    {localStorage.getItem("phone")}
                  </p>
                </div>
              </>
            }

            <div className="purchase-content">
              <div className="purchase-grid-title">
                <h3 className="no-margin-padding">Sr #</h3>
                <h3 className="no-margin-padding">Item</h3>
                <h3 className="no-margin-padding">Quantity</h3>
              </div>

              <div style={{ border: "1px solid black" }}>
                {bill &&
                  bill?.quantity.map((item, index) => {
                    return (
                      <div className="purchase-grid-content">
                        <p className="no-margin-padding purchase-col">
                          {index + 1}
                        </p>
                        <p className="no-margin-padding purchase-col">
                          {item.name}
                        </p>

                        <p className="no-margin-padding purchase-col">
                          {item.saleQuantity}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default WarehouseBills;
